import { Chip, Box } from "@mui/material";

export default function SelectFilterChip({ id, values }: { id: string; values: string[] }) {
  const displayPlusOne = values.length > 1;
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.3,
        width: 1,
      }}
    >
      <Box
        component="span"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: displayPlusOne ? "calc(100% - 50px)" : "auto",
        }}
      >
        {values[0]}
      </Box>
      {displayPlusOne && (
        <Chip
          sx={{ height: "20px" }}
          color="primary"
          size="small"
          key={`filter-chip-${id}`}
          label={`+${values.length - 1}`}
        />
      )}
    </Box>
  );
}
